import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { approvePublicApiUserUrl } from "../../../../../config";
import api from "../../../../../api";
import { Status } from "../../../../../common/constants";
import { RootState } from "../../../../../store";
import { IInitialSliceState } from "../../../../../common/types/commonTypes";

interface IApprovePublicApiResponse {
  message: string;
}

export interface IApprovePublicApiPayload {
  orgAdminEmail: string;
  isSuperAdminApproved: boolean;
  orgId: string;
}

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

export const approvePublicApiUser = createAsyncThunk<
  IApprovePublicApiResponse,
  IApprovePublicApiPayload,
  { rejectValue: string }
>(
  "approvePublicApiUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(approvePublicApiUserUrl, payload);
      return response.data as IApprovePublicApiResponse;
    } catch (err: any) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Failed to update approval";
      return rejectWithValue(msg);
    }
  }
);

const approveSlice = createSlice({
  name: "approvePublicApiUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(approvePublicApiUser.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
        state.msg = null;
      })
      .addCase(approvePublicApiUser.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload.message;
      })
      .addCase(approvePublicApiUser.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Error occurred while updating";
        state.status = Status.FAILED;
      });
  },
});

export const selectApprovePublicApi = (state: RootState) =>
  state.approvePublicApiUser;

export const reducer = approveSlice.reducer;
